import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealEquityField({ value, error, setValue, setError }) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='equity-helper-text'
          label='Equity'
          id='equity'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
          sx={{ input: { textAlign: 'right' } }}
        />

        {error ? (
          <FormHelperText id='equity-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='equity-helper-text'>
            Enter the total amount of all equity used to purchase the asset.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
